import Captcha from '../Captcha';
import '@hcaptcha/loader/dist/polyfills.js';
import '@hcaptcha/loader/dist/index.es5.js';

export type Hcaptcha = {
  execute: Function;
  render: Function;
};

type HCaptchaLoaderOptions = {
  scriptLocation: HTMLElement;
  scriptSource?: string;
};

declare global {
  interface Window {
    hCaptchaLoadCallback: Function;
    hCaptchaLoader: Function;
    hcaptcha: Hcaptcha;
  }
}

export default class HCaptcha extends Captcha {
  private widgetId: string;
  private hcaptcha: Hcaptcha;
  protected async load(): Promise<void> {
    const container = this.createContainer();
    try {
      let hCaptchaLoaderOptions: HCaptchaLoaderOptions = {
        scriptLocation: document.body,
      };
      if (this.getSdkEndpoint()) {
        hCaptchaLoaderOptions.scriptSource = this.getSdkEndpoint();
      }
      this.hcaptcha = await window.hCaptchaLoader(hCaptchaLoaderOptions);
      this.widgetId = await this.render(container);
    } catch (err) {
      const onLoadPromise = new Promise((resolve) => {
        window.hCaptchaLoadCallback = resolve;
      });
      await this.loadScript();
      // Wait for onload callback from hcaptcha script
      await onLoadPromise;
      this.hcaptcha = window.hcaptcha;
      this.widgetId = await this.render(container);
    }
  }

  protected async execute(action?: string): Promise<string> {
    const {response} = await this.hcaptcha.execute(this.widgetId, {async: true});
    return response;
  }

  protected getScriptURL(): string {
    return 'https://js.hcaptcha.com/1/api.js?onload=hCaptchaLoadCallback&render=explicit';
  }

  private async render(container: HTMLDivElement): Promise<string> {
    return this.hcaptcha.render(container, {
      sitekey: this.getSiteKey(),
    });
  }

  private createContainer(): HTMLDivElement {
    let container = document.createElement('div');
    container.id = 'captcha_container';
    container.setAttribute('class', container.id);
    document.body.appendChild(container);
    return container;
  }
}
